import {Mapping} from "../mapping";

export abstract class MapHandler {

  protected constructor(public target: object) {
  }

  abstract map(mappings: Array<Mapping>): object;
}
